<p-toast></p-toast>

<app-page-shell *ngIf="canViewYards; else noPermission">
  <app-page-hero
    eyebrow="Container Tracking Setup"
    title="Terminal Yard Setup"
    subtitle="Setup is split by master data area. Open each page to list records, or use its dedicated add/edit form page.">
    <div actions>
      <p-button label="New Facility" icon="pi pi-plus" routerLink="/container-tracking/setup/facilities/add"></p-button>
    </div>
  </app-page-hero>

  <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

  <div class="setup-hub-grid">
    <a class="setup-hub-card" routerLink="/container-tracking/setup/facilities">
      <span><i class="pi pi-sitemap"></i></span>
      <div>
        <strong>Terminal Facilities</strong>
        <small>Port terminals, bonded yards, CFS, depots, carriers, and warehouse-linked facilities.</small>
      </div>
      <p-tag [value]="facilities.length + ' records'" severity="info"></p-tag>
    </a>

    <a class="setup-hub-card" routerLink="/container-tracking/setup/areas">
      <span><i class="pi pi-map"></i></span>
      <div>
        <strong>Yard Areas</strong>
        <small>Import/export stacks, inspection areas, reefers, empty stacks, and customs holds.</small>
      </div>
      <p-tag [value]="yardAreas.length + ' records'" severity="success"></p-tag>
    </a>

    <a class="setup-hub-card" routerLink="/container-tracking/setup/yard-slots">
      <span><i class="pi pi-table"></i></span>
      <div>
        <strong>Yard Slots</strong>
        <small>Block, row, bay, tier, TEU capacity, occupancy authority, and container compatibility.</small>
      </div>
      <p-tag [value]="yardSlots.length + ' records'" severity="warn"></p-tag>
    </a>

    <a class="setup-hub-card" routerLink="/container-tracking/setup/charge-rules">
      <span><i class="pi pi-calculator"></i></span>
      <div>
        <strong>Yard Charge Rules</strong>
        <small>Storage, demurrage, detention, lift-on, and lift-off rule setup.</small>
      </div>
      <p-tag [value]="chargeRules.length + ' records'" severity="warn"></p-tag>
    </a>

    <a class="setup-hub-card" routerLink="/container-tracking/setup/execution-values">
      <span><i class="pi pi-list-check"></i></span>
      <div>
        <strong>Execution Values</strong>
        <small>Transport modes, storage facility types, area types, leg statuses, and milestones.</small>
      </div>
      <p-tag [value]="(transportModes.length + storageFacilityTypes.length + areaTypes.length + legStatuses.length + lifecycleMilestones.length) + ' values'" severity="info"></p-tag>
    </a>
  </div>
</app-page-shell>

<ng-template #noPermission>
  <app-page-shell>
    <app-page-data-panel title="Container Tracking Setup" subtitle="You do not have permission to view container tracking setup."></app-page-data-panel>
  </app-page-shell>
</ng-template>
